<ng-container>
  @if (audienceNavigation) {
    <dotcom-frontend-loader [componentData]="audienceNavigation" />
  }

  <div class="header">
    @if (headerData) {
      <header
        [ngClass]="{
          'header--sticky': isSticky,
          tall: isTall(),
          'campaign-article-header': isCampaignOrArticlePage,
          'language-header': isLanguageHeader
        }"
        lg-header
      >
        @if (!isTall()) {
          <ng-container>
            <lg-header-logo
              (click)="interactionClickEvent(headerLogoUrl, 'logo-link', 'L&G')"
              [alt]="headerLogoAltText"
              [href]="headerLogoUrl"
              [src]="headerLogoImage"
            />

            @if (isCampaignOrArticlePage && secondaryPartnerLogo) {
              <lg-header-logo
                [src]="secondaryPartnerLogo"
                [alt]="secondaryPartnerLogoAltText"
                [href]="headerLogoUrl"
                (click)="
                  interactionClickEvent(
                    headerLogoUrl,
                    'logo-link',
                    secondaryPartnerLogoAltText
                  )
                "
              />
            }

            @if (
              isCampaignOrArticlePage &&
              pageHeaderStyle !== "standard" &&
              !secondaryPartnerLogo &&
              headerData.headerPartnerLogo
            ) {
              <lg-header-logo
                [src]="headerData.headerPartnerLogo"
                [alt]="headerData.headerPartnerLogoAltText"
                [href]="headerLogoUrl"
                (click)="
                  interactionClickEvent(
                    headerLogoUrl,
                    'logo-link',
                    headerData.headerPartnerLogoAltText
                  )
                "
              />
            }

            @if (navigationComponent) {
              <dotcom-frontend-loader
                [componentData]="navigationComponent"
                cssClass="navigation"
              />
            } @else {
              <ng-container [ngTemplateOutlet]="cta"></ng-container>
            }
          </ng-container>
        } @else {
          <div class="header__row header__row--logo">
            <lg-header-logo
              (click)="interactionClickEvent(headerLogoUrl, 'logo-link', 'L&G')"
              [alt]="headerLogoAltText"
              [href]="headerLogoUrl"
              [src]="headerLogoImage"
            />

            @if (headerData.headerPartnerLogo) {
              <lg-header-logo
                (click)="
                  interactionClickEvent(
                    headerLogoUrl,
                    'logo-link',
                    headerData.headerPartnerLogoAltText
                  )
                "
                [alt]="headerData.headerPartnerLogoAltText"
                [href]="headerLogoUrl"
                [src]="headerData.headerPartnerLogo"
              />
            } @else {
              <div class="header__title">
                {{ headerData.headerTitle }}
              </div>
            }
            <ng-container [ngTemplateOutlet]="cta"></ng-container>
          </div>

          @if (navigationComponent) {
            <div class="header__row header__row--navigation">
              <dotcom-frontend-loader
                [componentData]="navigationComponent"
                cssClass="navigation"
              ></dotcom-frontend-loader>
            </div>
          }
        }
      </header>
    }

    @if (isSticky) {
      <div
        [class]="{
          'header__sticky-placeholder': true,
          'header__sticky-placeholder--tall': isTall()
        }"
      ></div>
    }
  </div>

  <ng-template #cta>
    @if (ctaButtons && !navigationComponent) {
      <div class="header__buttons">
        @if (isCampaignOrArticlePage && ctaButtons.length > 0) {
          <span
            class="header__buttons--mobile-menu-button js-nav-menu-button"
            [ngClass]="{ active: mobileNav }"
            (click)="
              toggleMobileNav($event);
              interactionClickEvent('/', 'Toggle mobile nav', 'Mobile nav')
            "
          >
            <lg-icon name="hamburger-menu"></lg-icon>
          </span>
          <div
            class="mobile-ctas opens-top"
            [ngClass]="{ 'open-top': mobileNav }"
          >
            <div class="ctas-container">
              @for (button of ctaButtons; let i = $index; track i) {
                <dotcom-frontend-loader
                  cssClass="header__button"
                  [componentData]="button"
                />
              }
            </div>
          </div>
        } @else {
          @for (button of ctaButtons; let i = $index; track i) {
            <dotcom-frontend-loader
              [componentData]="button"
              cssClass="header__button"
            />
          }
        }
      </div>
    }
  </ng-template>
</ng-container>
